import { saveAs } from "file-saver";

export function exportCanvas(canvas, options) {
  const clientWidth = canvas.clientWidth;
  const clientHeight = canvas.clientHeight;

  let hidden_canv = document.createElement("canvas");
  hidden_canv.style.display = "none";
  document.body.appendChild(hidden_canv);
  hidden_canv.width = clientWidth;
  hidden_canv.height = clientHeight;

  const { height, width, startX, startY } = options;
  let hidden_ctx = hidden_canv.getContext("2d");
  hidden_ctx.drawImage(
    canvas,
    startX, //Start Clipping
    startY, //Start Clipping
    width, //Clipping Width
    height, //Clipping Height
    0, //Place X
    0, //Place Y
    clientWidth, //Place Width
    clientHeight //Place Height
  );
  let data = hidden_canv.toDataURL();
  document.body.removeChild(hidden_canv);
  return data;
}

export function toPNG(blob, fileName) {
  // @ts-ignore
  saveAs(blob, fileName);
}
